import store from '../../store'

export default (to, from, next) => {
  // If the path is for NOT logged user
  if (to.matched.some(m => 'logged' in m.meta && !m.meta.logged)) {
    // If user is logged in, go to home
    if (store.state.auth.logged) {
      // return next({name: `${store.state.auth.role}Home`})
      return next({name: `Home`})
    } else {
      // Otherwise, go to the next path
      return next()
    }
  }
}



// WEBPACK FOOTER //
// ./src/router/middleware/guest.js